import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DialogButtonConfigurationEnum } from './models/enums/dialog-button-configuration.enum';
import { GeneralPromptDialogDataModel } from './models/general-prompt-dialog-data.model';

@Component({
    selector: 'sl-general-prompt-dialog',
    templateUrl: './general-prompt.dialog.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GeneralPromptDialog implements OnInit {
    readonly DialogButtonConfigurationEnum = DialogButtonConfigurationEnum;

    readonly data: GeneralPromptDialogDataModel = inject(MAT_DIALOG_DATA);

    private readonly matDialogRef = inject(MatDialogRef);

    ngOnInit(): void {
        this.matDialogRef.keydownEvents().subscribe(event => {
            if (event.key === 'Escape' && this.data.disableClose) {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.matDialogRef.close(false);
            }
        });
    }
}
